import React from 'react';
import LadderEmoji from 'react/elements/LadderEmoji';

/**
 * Renders a message's emoji reactions as a row of pills (emoji + count). A pill
 * the current user has reacted with is highlighted; clicking any pill toggles the
 * current user's own reaction off/on.
 */
export function ReactionPillsComponent({ message }) {
	const reactions = message.reactions;
	if(!reactions || !reactions.length) {
		return null;
	}

	return (
		<span className='chat_message_reactions'>
			{reactions.map((reaction) => {
				const reacted = message.hasMyReaction(reaction.emoji);
				const onClick = (e) => {
					e.stopPropagation();
					message.toggleReaction(reaction.emoji);
				};
				return (
					<button
						key={reaction.emoji}
						type='button'
						className={'reaction_pill' + (reacted ? ' reacted' : '')}
						onClick={onClick}
						title={reacted ? 'Remove your reaction' : 'React'}
					>
						<LadderEmoji emoji={reaction.emoji} size={18} tooltip={false} />
						<span className='reaction_count'>{reaction.count}</span>
					</button>
				);
			})}
		</span>
	);
}
